import styled from "styled-components";
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35";

export const CCPCollectionsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -5px;
    min-height: 34px;
    align-items: center;

    @media print {
        display: none;
    }
`;

export const CCPCollectionBadge = styled.div<{ $noCta: boolean, $isInfoBadgeOnly:boolean }>`
    border-radius: 100px;
    background: ${({ theme }) => theme ? theme.v3.colors.grey96 : null};
    width: auto;
    margin: ${({ $isInfoBadgeOnly  }) => $isInfoBadgeOnly  ? "3px 4px" : "5px 7px"};
    display: flex;
    outline: 1px solid white;
    align-items: center;
    
    svg {
        &:hover {
            stroke: ${({ theme }) => theme ? theme.v3.colors.red : null};
        }
    }

    > div {
        display: inline-flex;

        &:first-child {
            cursor: ${({ theme,  $noCta  }) => theme && !$noCta  ? "pointer" : null};
            padding: ${({ $isInfoBadgeOnly  }) => $isInfoBadgeOnly  ? "2px 10px" : "4px 4px 4px 8px"};

            &:hover {
                ${V3CaptionGrey35} {
                    color: ${({ theme,  $noCta, $isInfoBadgeOnly  }) => theme && !$noCta && !$isInfoBadgeOnly  ? theme.v3.colors.blue : null};
                }
            }
        }

        &:nth-child(2) {
            cursor: pointer;
            padding: 4px 8px 4px 0px;
            padding-left: 4px;

            &:hover {
                svg {
                    path {
                        stroke:  ${({ theme }) => theme ? theme.v3.colors.red : null};
                    }
                }
            }
        }
    }
`;